import { defineDomainTranslations } from './defineDomainTranslations';

const en = {
  'sidebarNav.assets': 'Assets',
  'sidebarNav.home': 'Home',
  'sidebarNav.newRecording': 'Record new video',
  'sidebarNav.newTranslation': 'Translate new video',
  'sidebarNav.plan.free': 'Free plan',
} as const;

type Translation = Record<keyof typeof en, string>;

const es = {
  'sidebarNav.assets': 'Recursos',
  'sidebarNav.home': 'Inicio',
  'sidebarNav.newRecording': 'Grabar un vídeo nuevo',
  'sidebarNav.newTranslation': 'Traducir un vídeo nuevo',
  'sidebarNav.plan.free': 'Plan gratuito',
} satisfies Translation;

const pt = {
  'sidebarNav.assets': 'Recursos',
  'sidebarNav.home': 'Início',
  'sidebarNav.newRecording': 'Gravar um novo vídeo',
  'sidebarNav.newTranslation': 'Traduzir um novo vídeo',
  'sidebarNav.plan.free': 'Plano gratuito',
} satisfies Translation;

const fr = {
  'sidebarNav.assets': 'Ressources',
  'sidebarNav.home': 'Accueil',
  'sidebarNav.newRecording': 'Enregistrer une nouvelle vidéo',
  'sidebarNav.newTranslation': 'Traduire une nouvelle vidéo',
  'sidebarNav.plan.free': 'Offre gratuite',
} satisfies Translation;

const it = {
  'sidebarNav.assets': 'Risorse',
  'sidebarNav.home': 'Home',
  'sidebarNav.newRecording': 'Registra un nuovo video',
  'sidebarNav.newTranslation': 'Traduci un nuovo video',
  'sidebarNav.plan.free': 'Piano gratuito',
} satisfies Translation;

const ru = {
  'sidebarNav.assets': 'Ресурсы',
  'sidebarNav.home': 'Главная',
  'sidebarNav.newRecording': 'Записать новое видео',
  'sidebarNav.newTranslation': 'Перевести новое видео',
  'sidebarNav.plan.free': 'Бесплатный тариф',
} satisfies Translation;

export const SIDEBAR_NAV_TRANSLATIONS = defineDomainTranslations({ en, es, fr, it, pt, ru });
